import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";
import Card from "../../Components/Card/card";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Slider from "react-slick";
import { useRef, useState, useEffect } from "react";
import Eventcard from "../../Newdesign/popularevents/eventcard";

const NearByEvents = ({ nearByEvents }) => {
  const { t } = useTranslation();
  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <MdKeyboardArrowLeft
        className={className}
        style={{
          ...style,
          color: "#483f50",
          height: "55px",
          width: "55px",
          backgroundColor: "white",
          borderRadius: "50%",
        }}
        onClick={onClick}
      />
    );
  };
  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <MdKeyboardArrowRight
        className={className}
        style={{
          ...style,
          color: "#483f50",
          height: "55px",
          width: "55px",
          backgroundColor: "white",
          borderRadius: "50%",
        }}
        onClick={onClick}
      />
    );
  };
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: nearByEvents?.length > 2 ? 3 : nearByEvents?.length,
    slidesToScroll: 1,
    initialSlide: 0,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
  };

  const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
  
    useEffect(() => {
      const handleMouseUp = () => {
        setIsDragging(false);
      };
  
      const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 3;
        scrollRef.current.scrollLeft = scrollLeft - walk;
      };
  
      const handleTouchMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 3;
        scrollRef.current.scrollLeft = scrollLeft - walk;
      };
  
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.addEventListener("touchmove", handleTouchMove);
      document.addEventListener("touchend", handleMouseUp);
  
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleMouseUp);
      };
    }, [isDragging, startX, scrollLeft]);
  
    const handleMouseDown = (e) => {
      setIsDragging(true);
      setStartX(e.pageX - scrollRef.current.offsetLeft);
      setScrollLeft(scrollRef.current.scrollLeft);
    };
  
    const handleTouchStart = (e) => {
      setIsDragging(true);
      setStartX(e.touches[0].pageX - scrollRef.current.offsetLeft);
      setScrollLeft(scrollRef.current.scrollLeft);
    };
  return (
    // <div>
    //   <h1 className="events-section-header">{t("Nearby Events")}</h1>

    //   {nearByEvents?.length > 0 ? (
    //     <div
    //       style={{
    //         background: "#EBD4FF",
    //         padding: "25px",
    //         borderRadius: "24px",
    //         minHeight: "367px",
    //       }}
    //     >
    //       <Swiper
    //         breakpoints={{
    //           100: {
    //             slidesPerView: 1,
    //           },
    //           576: {
    //             slidesPerView: 1,
    //           },
    //           768: {
    //             slidesPerView: 2,
    //           },
    //           992: {
    //             slidesPerView: 3,
    //           },
    //         }}
    //         slidesPerView={3}
    //         spaceBetween={30}
    //         pagination={{
    //           clickable: true,
    //         }}
    //         modules={[Pagination]}
    //         className="mySwiper"
    //       >
    //         {nearByEvents?.map((event, index) => (
    //           <SwiperSlide key={index}>
    //             <Card className="card" event={event} index={index} />
    //           </SwiperSlide>
    //         ))}
    //       </Swiper>
    //     </div>
    //   ) : (
    //     // <Slider {...settings}>
    //     //   {nearByEvents?.map((event, index) => (
    //     //     <Card className="card" key={index} event={event} index={index} />
    //     //   ))}
    //     // </Slider>
    //     // <div className="row gap-3 p-3">
    //     //   {nearByEvents?.map((event, index) => (
    //     //     <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"><Card className="card" key={index} event={event} index={index} /></div>
    //     //   ))}
    //     // </div>

    //     <div
    //       className="events-div"
    //       style={{
    //         background: "#EBD4FF",
    //         padding: "20px",
    //         borderRadius: "24px",
    //       }}
    //     >
    //       <span className="events-section-header text-center">
    //         You Don't Have Any Nearby Event Right Now
    //       </span>
    //     </div>
    //   )}
    // </div>
    <div className="-mx-20 md:mx-auto font-poppins bg-[#EBD4FF] " style={{ height: "590px" }}>
        <h1 className="mb-3 text-xl font-bold md:text-3xl mt-14 ml-28 p-1 ">{t("Near By Events")}</h1>
        {Array.isArray(nearByEvents) && nearByEvents.length > 0 ? (
          <div className="relative bg-[#EBD4FF]">
            <div className="absolute top-0 left-0 h-full bg-[#EBD4FF] " style={{ width: "110px" }}></div>
            <div
              className={`overflow-x-auto pl-28 ${nearByEvents.length >= 4 ? 'custom-scroll' : ''}`}
              ref={scrollRef}
              onMouseDown={nearByEvents.length >= 4 ? handleMouseDown : null}
              onTouchStart={nearByEvents.length >= 4 ? handleTouchStart : null}
              style={{ cursor: isDragging ? "grabbing" : "grab", overflowY: "hidden" }}
            >
              <div className="flex w-full gap-4 ">
                {nearByEvents.map((event, index) => (
                  <div key={index} className="inline-block">
                    <Eventcard event={event} index={index} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <span className="block text-lg font-semibold text-center">
            There is no Nearby Event Right Now
          </span>
        )}
    </div>
  );
};

export default NearByEvents;
